import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query AdmissionWays($page: Int, $perPage: Int, $search: String) {
    AdmissionWays(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        name
        templateInvestmentName
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

/** Type each item in response data*/
export interface GetAllItem {
  id: number;
  name: string;
  templateInvestmentName: string;
}

export const responseGetAllKey = "AdmissionWays";

/** Type response data */
export interface GetAllGql {
  AdmissionWays: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
